import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { SearchedInfo } from '../models/search-info';
import { Observable, of } from 'rxjs';
import { convertToXY, DnvLatLng, DnvMapInfo, SearchItem } from 'dnv-lib';

import { LocationCoordinate, SearchCoordinatesPayload, SearchLocation, ToolboxMailMergeState } from '../state-management';

@Injectable()
export class EditFeatureService {

  editUrl = 'api/EditPermission/';
  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })

  };
  httpOptionsString = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    }),
    responseType: 'text' as const
  };

  constructor(
    private httpClient: HttpClient
  ) { }

  getEditPermission(): any {
    return this.httpClient.get(this.editUrl, this.httpOptions);
  }

  getMaxAssetId(url: string, name: string): any {
    const query = url + '/query?where=1%3D1&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&distance=&units=esriSRUnit_Foot&relationParam=&outFields=' + name + '+&returnGeometry=false&maxAllowableOffset=&geometryPrecision=&outSR=&having=&gdbVersion=&historicMoment=&returnDistinctValues=false&returnIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&orderByFields=' + name + '+desc&groupByFieldsForStatistics=&outStatistics=&returnZ=false&returnM=false&multipatchOption=xyFootprint&resultOffset=&resultRecordCount=1&returnTrueCurves=false&returnExceededLimitFeatures=false&quantizationParameters=&returnCentroid=false&sqlFormat=none&resultType=&featureEncoding=esriDefault&f=pjson';

    return this.httpClient.get(query, this.httpOptions);
  }

  getEditFeatureFields(url: string): any {
    return this.httpClient.get(url + '?f=pjson', this.httpOptions);
  }

  getEditRequiredFields(): any {
    return this.httpClient.get('api/EditRequiredFields', this.httpOptions);
  }

  getEditReadOnlyFields(): any {
    return this.httpClient.get('api/EditReadOnlyFields', this.httpOptions);
  }

  getToolsPermissions(): any {
    return this.httpClient.get('api/ToolsPermissions', this.httpOptions);
  }
}
